import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";
import { initHubSpotSignupTracking } from "./lib/hubspotSignupTracking";

initHubSpotSignupTracking();

createRoot(document.getElementById("root")!).render(<App />);

